<template>
<section v-if="enabledPromotions.length" data-component="PromotionActivePromotions.vue" class="pl-5 active-promotions">
	<div class="flex items-center justify-between" :class="{'ml-5': ScreenSize < 1}">
		<span class="block mb-2 heading-normal">Tu Cię promujemy</span>
	</div>

	<PromotionTable
		:module="'active-promotions'"
		:promotions="enabledPromotions"
		:isPromotionsLimitReached="isPromotionsLimitReached"
		class="max-h-72"
	/>
</section>
</template>
<script lang="ts">
import { PropType, defineAsyncComponent } from 'vue';
import { mapState } from 'pinia';
import { useAppStore } from '../../../stores/app';
import EnabledPromotion from '../../../types/interfaces/promotion/EnabledPromotion';

export default {
	name: 'PromotionActivePromotions',
	components: {
		PromotionTable: defineAsyncComponent(() => import('./common/PromotionTable.vue')),
	},
	props: {
		apiNamespace: {
			type: String,
			required: true,
		},
		enabledPromotions: {
			type: Array as PropType<EnabledPromotion[]>,
			required: true,
		},
		isPromotionsLimitReached: {
			type: Boolean,
			required: true,
		},
	},
	emits: ['toggle-change-promotion-modal', 'toggle-full-promotion-item-visibility', 'assign-enabled-promotions-current-sort', 'assign-enabled-promotions-current-sort-dir', 'get-enabled-promotions'],
	data() {
		return {
			enabledPromotionsCurrentSort: 'name',
			enabledPromotionsCurrentSortDir: 'asc',
		};
	},
	computed: {
		...mapState(useAppStore, [
			'isAdminModule',
		]),

		enabledPromotionsSum() {
			return this.enabledPromotions.reduce((accumulator, promotion) => accumulator + promotion.price, 0);
		},
	},
	watch: {
		enabledPromotionsCurrentSort(value) {
			this.$emit('assign-enabled-promotions-current-sort', value);
		},
		enabledPromotionsCurrentSortDir(value) {
			this.$emit('assign-enabled-promotions-current-sort-dir', value);
		},
	},
	methods: {
		sortEnabledPromotions(key: string) {
			if (key === this.enabledPromotionsCurrentSort) {
				this.enabledPromotionsCurrentSortDir = this.enabledPromotionsCurrentSortDir === 'asc' ? 'desc' : 'asc';
			}

			this.enabledPromotionsCurrentSort = key;
		},
		showCategoriesList() {
			const category = document.getElementById('category');

			if (category) {
				category.focus();
			}
		},
	},
};
</script>
<style lang="scss" scoped>
.active-promotions {
	@media only screen and (max-width: 640px) {
		padding-left: 0;
	}
}

</style>
